import { CurrentUser } from "Roblox";
import catalogModule from '../catalogModule';

function catalogService($log, $q, httpService, eventStreamService, catalogConstants, utilityService) {
    "ngInject";

    return {
        getMetadataFromApi: function () {
            return httpService.httpGet(catalogConstants.endpoints.getMetadata);
        },

        checkEnrollment: function (testNames) {
            var data = [];
            var userId = CurrentUser.userId;
            testNames.forEach(function (name) {
                data.push({
                    SubjectType: catalogConstants.abTestingParams.subjectType,
                    SubjectTargetId: userId,
                    ExperimentName: name
                });
            });
            return httpService.httpPost(catalogConstants.endpoints.enrollAbTesting, data);
        },

        getSearchOptions: function () {
            var urlConfig = catalogConstants.endpoints.getSearchOptionsUrl;

            return httpService.httpGet(urlConfig);
        },

        getNavigationMenuItems: function () {
            return httpService.httpGet(catalogConstants.endpoints.getNavigationMenuItems);
        },

        getSearchItems: function (params, isFullScreenEnabled) {
            const { numberOfSearchItems, numberOfSearchItemsForFullScreen } = catalogConstants;
            const urlParams = {
                limit: isFullScreenEnabled ? numberOfSearchItemsForFullScreen : numberOfSearchItems
            }
            Object.assign(urlParams, params);
            return httpService.httpGet(catalogConstants.endpoints.getSearchItems, urlParams);
        },

        getCatalogItemDetails: function (itemsMapKey) {
            const { endpoints, priceStatus, itemRestrictionTypes } = catalogConstants;
            let items = [];
            for (const key in itemsMapKey) {
                items.push(itemsMapKey[key]);
            }
            const requestData = {
                "items": items
            }
            return httpService.httpPost(endpoints.getCatalogItemDetails, requestData)
                            .then(function success(result) {
                                const returnResult = result && result.data ? result.data : [];
                                returnResult.forEach(function (item) {
                                    const { id } = item;
                                    item.key = itemsMapKey[id].key;
                                    if (item.priceStatus === priceStatus.free) {
                                        item.isFree = true;
                                    }
                                    utilityService.mapItemRestrictionIcons(item);
                                    utilityService.mapItemStatusIconsAndLabels(item);
                                    utilityService.buildUserLink(item);
                                });
                                return returnResult;
                            });
        }
    }
}

catalogModule.factory("catalogService", catalogService);

export default catalogService;